import React, { useState, useEffect } from 'react';

const Photos = ({ photos, selectedPhoto }) => {
  const [currentPhoto, setCurrentPhoto] = useState(selectedPhoto || (photos && photos.length > 0 ? photos[0] : null));
  const [currentIndex, setCurrentIndex] = useState(photos ? photos.indexOf(currentPhoto) : 0);

  useEffect(() => {
    if (selectedPhoto) {
      setCurrentPhoto(selectedPhoto);
      setCurrentIndex(photos ? photos.indexOf(selectedPhoto) : 0);
    } else if (photos && photos.length > 0) {
      setCurrentPhoto(photos[0]);
      setCurrentIndex(0);
    }
  }, [selectedPhoto, photos]);

  const handleNextPhoto = () => {
    if (photos && currentIndex < photos.length - 1) {
      const nextIndex = currentIndex + 1;
      setCurrentPhoto(photos[nextIndex]);
      setCurrentIndex(nextIndex);
    }
  };

  const handlePreviousPhoto = () => {
    if (photos && currentIndex > 0) {
      const prevIndex = currentIndex - 1;
      setCurrentPhoto(photos[prevIndex]);
      setCurrentIndex(prevIndex);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowRight') {
      handleNextPhoto();
    } else if (event.key === 'ArrowLeft') {
      handlePreviousPhoto();
    }
  };

  useEffect(() => {
    // Add event listener for keydown events
    window.addEventListener('keydown', handleKeyDown);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [currentIndex, photos]);

  return (
    <section id="photos">
      {currentPhoto ? (
        <div className="photo-container">
          <img src={currentPhoto} alt="Selected Photo" className="enlarged-photo" />
          <div className="photo-overlay">
            <button className="photo-button left" onClick={handlePreviousPhoto}>&lt;</button>
            <button className="photo-button right" onClick={handleNextPhoto}>&gt;</button>
          </div>
        </div>
      ) : (
        <p>No photos available</p>
      )}
    </section>
  );
};

export default Photos;
